export default {
  data() {
    return {
      planning: [],
    };
  },
  methods: {
    /**
     * Fetch planning, projects and departments.
     * @param fetchProjects
     * @param fetchDepartments
     * @returns {Promise<*>}
     */
    async fetchPlanning(fetchProjects, fetchDepartments) {
      this.$startLoading('planning');

      // fetch planning, projects and departments
      const [planning, projects, departments] = await Promise.all([
        this.$api.planning.index(),
        fetchProjects,
        fetchDepartments,
      ]);

      // get months
      const months = this.$getMonths();

      // map planning
      const mappedPlanning = planning.reduce((acc, { Year, Month, Hours, DepartmentID, ProjectID }) => ({ ...acc, [`${ProjectID}-${DepartmentID}-${this.$getFormat(Year, Month)}`]: Hours }), {});

      // map departments
      const departmentsById = departments.reduce((acc, department) => ({ ...acc, [department.ID]: department }), {});

      // generate planning array
      projects.forEach(({ Name: ProjectName, ID: ProjectID, DepartmentID: OwnerID, DepartmentIDs, ProjectCategoryID: CategoryID }) => {
        DepartmentIDs.forEach((DepartmentID) => {
          // generate planning
          const planning = {
            ProjectID,
            OwnerID,
            DepartmentID,
            Project: ProjectName,
            Owner: departmentsById[OwnerID].Number,
            Department: departmentsById[DepartmentID].Number,
            CategoryID,
          };
          months.forEach(({ format }) => {
            const Hours = mappedPlanning[`${ProjectID}-${DepartmentID}-${format}`];
            planning[format] = (typeof Hours !== 'undefined') ? Hours : '';
          });
          // fill structures
          // this.planning._mapped[ProjectID][DepartmentID] = planning;
          this.planning.push(planning);
        });
      });

      this.$stopLoading('planning');
      return planning;
    },
    /**
     * Update planning.
     * @param planning
     * @param month
     * @param oldValue
     * @param newValue
     * @returns {Promise<void>}
     */
    async updatePlanning(planning, month, oldValue, newValue) {
      const { ProjectID: projectId, DepartmentID: departmentId } = planning;

      // set planning to the new value
      planning[month] = newValue;

      // prepare api data
      const [apiYear, apiMonth] = month.split('-').map(number => parseInt(number, 10));

      try { // save new value
        this.$startLoading(`${departmentId}-${projectId}-${month}`);
        if (newValue === '') {
          await this.$api.planning.remove(departmentId, projectId, apiYear, apiMonth);
        } else {
          await this.$api.planning.update(departmentId, projectId, apiYear, apiMonth, newValue);
        }
        this.$stopLoading(`${departmentId}-${projectId}-${month}`);
      } catch (err) {
        planning[month] = oldValue;
        this.$stopLoading(`${departmentId}-${projectId}-${month}`);
        throw err;
      }
    },
  },
};
